module.exports = __webpack_public_path__ + "img/12.2c3d16a6.jpg";